
  <div class="d-flex justify-content-between align-items-center mt-3 mb-5">
    <p class="page-title mb-0">Manage Rules</p>
  </div>

  <div class="card card-nav-tabs rounded-lg border-0">
    <div class="card-header card-header-primary shadow rounded-lg">
      <div class="nav-tabs-navigation">
        <div class="nav-tabs-wrapper">
          <ul class="nav nav-tabs" data-tabs="tabs">
            <li
              class="nav-item"
              v-for="(tab, index) in tabs"
              :key="index"
              :class="{ active: active_tab === tab }"
              @click="set_active_tab(tab)"
            >
              <a class="text-dark text-decoration-none text-xs nav-link" href="#">
                {{ tab }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="card-body bg-white rounded-4 p-4">
      <div v-if="active_tab === 'Add Rules' ">
        <div class="mb-5">
          <button
            class="btn btn-primary-dark btn-sm text-xxs shadow mt-3 mb-2"
            data-bs-toggle="modal" data-bs-target="#create_new_rule"
          >
            + New Rule
          </button>
          <button
            class="btn btn-primary-dark btn-sm text-xxs shadow mt-3 mb-2 ms-2"
            @click="toggle_archived"
            :disabled="table_loading"
          >
            <span v-if="table_loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
            {{ show_archived ? 'Hide Archived' : 'Show Archived' }}
          </button>

          <!-- Table for compliance rules -->
          <GlobalTable
            v-if="table_data && table_data.length > 0"
            :headers="table_safe_headers"
            :data="table_data"
            table_id="compliance_rules_table"
          >
            <!-- Custom status rendering -->
            <template #column-status="{ value, row }">
              <span class="status-badge" :class="value.toLowerCase()">
                {{ value }}
                <span v-if="row.archived" class="badge bg-warning ms-1">Archived</span>
              </span>
            </template>

            <!-- Actions slot -->
            <template #actions="{ row }">
              <div class="d-flex gap-1">
                <!-- Archived rules actions -->
                <template v-if="get_raw_data(row.id).assignment?.is_archived">
                  <button
                    class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark me-2"
                    data-bs-toggle="modal"
                    data-bs-target="#archive_rule_modal"
                    @click="setup_archive_modal(get_raw_data(row.id), 'unarchive')"
                    :disabled="is_rule_unarchiving(row.id)">
                    <span v-if="is_rule_unarchiving(row.id)"
                          class="spinner-border spinner-border-sm me-1"
                          role="status"
                          aria-hidden="true"></span>
                    {{ is_rule_unarchiving(row.id) ? 'Unarchiving...' : 'Unarchive' }}
                  </button>
                </template>

                <!-- Non-archived rules actions -->
                <template v-else>
                  <button
                    class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark me-2"
                    data-bs-toggle="modal"
                    data-bs-target="#edit_new_rule"
                    @click="edit_the_rule(get_raw_data(row.id))">
                    Edit
                  </button>

                  <button
                    class="btn btn-primary-dark text-dark btn-sm rounded-3 small shadow me-2 text-xxs"
                    data-bs-toggle="modal"
                    data-bs-target="#archive_rule_modal"
                    @click="setup_archive_modal(get_raw_data(row.id), 'archive')"
                    :disabled="is_rule_archiving(row.id)">
                    <span v-if="is_rule_archiving(row.id)"
                          class="spinner-border spinner-border-sm me-1"
                          role="status"
                          aria-hidden="true"></span>
                    {{ is_rule_archiving(row.id) ? 'Archiving...' : 'Archive' }}
                  </button>
                </template>

                <!-- History button - always available -->
                <button
                  class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark me-2"
                  data-bs-toggle="modal"
                  data-bs-target="#rule_history_modal"
                  @click="view_rule_history(get_raw_data(row.id))">
                  History
                </button>
              </div>
            </template>
          </GlobalTable>
        </div>
      </div>

      <div v-else-if="active_tab === 'Group Rules'">
        <GroupComplianceRules/>
      </div>

      <div v-else-if="active_tab === 'Import Rules'">
        <AssignComplianceRules/>
      </div>
    </div>
  </div>

<!-- Archive/Unarchive Reason Modal -->
 <teleport to="body">
<div id="archive_rule_modal" class="modal fade" tabindex="-1" aria-labelledby="archive_rule_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <h6 id="archive_rule_label" class="modal-title text-white">
          {{ archive_modal.action === 'archive' ? 'Archive Rule' : 'Unarchive Rule' }}
        </h6>
        <button type="button" class="modal-btn-close btn-close" aria-label="Close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <div class="mb-3">
          <p class="text-sm mb-3">
            You are about to {{ archive_modal.action }} the rule: 
            <strong>{{ archive_modal.rule?.name }}</strong>
          </p>
          <label class="form-label text-xxs">
            Please provide a reason for {{ archive_modal.action === 'archive' ? 'archiving' : 'unarchiving' }} this rule:
          </label>
          <textarea 
            v-model="archive_modal.reason" 
            class="form-control text-xxs rounded-small p-2 shadow-sm" 
            rows="3"
            :placeholder="`Enter reason for ${archive_modal.action}...`"
            maxlength="255"
          ></textarea>
          <small class="text-muted">{{ archive_modal.reason.length }}/255 characters</small>
        </div>
      </div>
      <div class="modal-footer border-0">
        <button 
          type="button" 
          :class="archive_modal.action === 'archive' ? 'btn btn-warning btn-sm' : 'btn btn-success btn-sm'"
          @click="handle_archive_action"
          :disabled="!archive_modal.reason.trim() || archive_modal.loading"
          data-bs-dismiss="modal">
          <span v-if="archive_modal.loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          {{ archive_modal.loading ? 'Processing...' : (archive_modal.action === 'archive' ? 'Archive Rule' : 'Unarchive Rule') }}
        </button>
      </div>
    </div>
  </div>
</div>
</teleport>

<!-- Add new rule Modal -->
 <teleport to="body">
<div id="create_new_rule" class="modal fade" tabindex="-1" aria-labelledby="create_rule_label" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <h6 id="create_rule_label" class="modal-title w-100 text-white">Create Compliance Rule</h6>
        <button type="button" class="modal-btn-close btn-close" aria-label="Close" data-bs-dismiss="modal"></button>
      </div>

      <div class="modal-body">
        <div class="row">
          <!-- Left Column: Rule Settings -->
          <div class="col-md-6 pe-md-4">
            <div class="form-group mb-3">
              <label class="modal-form-label form-label text-xxs">Rule Name:</label>
              <input type="text" v-model="new_rule.name" class="form-control text-xxs rounded-small p-2 shadow-sm" placeholder="Enter Rule Name" maxlength="50">
              <small v-if="errors.name" class="text-danger p-2 text-xxs fw-bold">{{ errors.name }}</small>
            </div>

            <div class="form-group mb-3">
              <label class="modal-form-label form-label text-xxs">Description:</label>
              <input type="text" v-model="new_rule.description" class="form-control text-xxs rounded-small p-2 shadow-sm" placeholder="Enter Description" maxlength="255">
              <small v-if="errors.description" class="text-danger p-2 text-xxs fw-bold">{{ errors.description }}</small>
            </div>

            <div class="form-group mb-3">
              <label class="modal-form-label form-label text-xxs">Select Data Point:</label>
              <select v-model="new_rule.data_point_id" class="form-select text-xxs rounded-small p-2 shadow-sm" :disabled="data_points_loading">
                <option disabled value="">{{ data_points_loading ? 'Loading data points...' : 'Select data point' }}</option>
                <option v-for="point in data_points" :key="point.id" :value="point.id">{{ point.name }}</option>
                <option v-if="data_points.length === 0 && !data_points_loading" disabled>No data points available</option>
              </select>
            </div>

            <div class="form-group mb-3">
              <label class="modal-form-label form-label text-xxs">Frequency:</label>
              <select v-model="new_rule.frequency" class="form-select text-xxs rounded-small p-2 shadow-sm">
                <option disabled value="">Select frequency</option>
                <option v-for="option in frequency_options" :key="option.value" :value="option.value">{{ option.label }}</option>
              </select>
              <small v-if="errors.frequency" class="text-danger p-2 text-xxs fw-bold">{{ errors.frequency }}</small>
            </div>

            <div class="form-group mb-3">
              <label class="modal-form-label form-label text-xxs">Grace Period:</label>
              <select v-model="new_rule.grace_period_selection" class="form-select text-xxs rounded-small p-2 shadow-sm mb-2">
                <option value="">Select grace period</option>
                <option v-for="option in grace_period_options" :key="option.value" :value="option.value">{{ option.label }}</option>
              </select>
              <div v-if="new_rule.grace_period_selection === 'custom'" class="d-flex align-items-center">
                <input type="number" v-model.number="new_rule.custom_grace_period_days" class="form-control text-xxs rounded-small p-2 shadow-sm me-2" min="0" max="365" placeholder="Enter days">
                <span class="text-xxs text-muted">day(s)</span>
              </div>
              <small v-if="errors.grace_period_days" class="text-danger p-2 text-xxs fw-bold">{{ errors.grace_period_days }}</small>
              <small class="text-muted text-xxs">Additional time allowed before marking as non-compliant</small>
            </div>

            <div class="form-group mb-3">
              <label class="modal-form-label form-label text-xxs">Maximum File Age:</label>
              <select v-model="new_rule.age_selection" class="form-select text-xxs rounded-small p-2 shadow-sm mb-2">
                <option value="">Select maximum file age</option>
                <option v-for="option in file_age_options" :key="option.value" :value="option.value">{{ option.label }}</option>
              </select>
              <div v-if="new_rule.age_selection === 'custom'" class="d-flex align-items-center">
                <input type="number" v-model.number="new_rule.custom_age_days" class="form-control text-xxs rounded-small p-2 shadow-sm me-2" min="1" max="3650" placeholder="Enter days">
                <span class="text-xxs text-muted">day(s)</span>
              </div>
              <small v-if="errors.allowed_age" class="text-danger p-2 text-xxs fw-bold">{{ errors.allowed_age }}</small>
              <small class="text-muted text-xxs">Files older than this will be considered non-compliant</small>
            </div>

            <!-- Notification Recipient -->
            <div class="form-group mb-3">
              <label class="modal-form-label form-label text-xxs">Notify Admin(s):</label>
              <div v-if="admin_options.length > 0" class="d-flex flex-column gap-1">
                <div v-for="admin in admin_options" :key="admin.id" class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :id="'notify_admin_' + admin.id"
                    :value="admin.id"
                    :checked="new_rule.notify_admin_ids.includes(admin.id)"
                    @change="toggle_admin(admin.id)"
                  >
                  <label class="form-check-label text-xxs" :for="'notify_admin_' + admin.id">
                    {{ admin.first_name }} {{ admin.last_name }} ({{ admin.email }})
                  </label>
                </div>
              </div>
              <div v-else>
                <small class="text-muted text-xxs">No admins available</small>
              </div>
              <div class="mt-2" v-if="new_rule.notify_admin_ids.length">
                <span class="badge bg-primary me-1 text-xxs" v-for="id in new_rule.notify_admin_ids" :key="id">
                  {{ get_admin_name(id) }}
                </span>
              </div>
              <small class="text-muted text-xxs">Selected admins will receive notifications when an entity fails compliance checks.</small>
              <small v-if="errors.notify_admin_ids" class="text-danger p-2 text-xxs fw-bold">{{ errors.notify_admin_ids }}</small>
            </div>


            <div class="form-group mb-3">
              <div class="form-check form-switch">
                <input 
                  class="form-check-input" 
                  type="checkbox" 
                  id="new_rule_active"
                  v-model="new_rule.is_active"
                >
                <label class="form-check-label text-xxs fw-medium" for="new_rule_active">
                  {{ new_rule.is_active ? 'Active' : 'Inactive' }}
                </label>
              </div>
              <small class="text-muted text-xxs">
                {{ new_rule.is_active ? 'Rule will run compliance checks after creation' : 'Rule will be saved but will not run checks' }}
              </small>
            </div>
          </div>

          <!-- Right Column: Compliance Check -->
          <div class="col-md-6 ps-md-4">
            <!-- Passing Status -->
            <div class="border-0 rounded-3 p-3 mb-4 border">
              <div class="d-flex align-items-center mb-2">
                <span class="me-2 text-success fs-5">✔</span>
                <p class="mb-0 fw-bold text-dark text-xs">Compliance Check Passing Status :</p>
              </div>
              <div>
                <label class="modal-form-label form-label text-xxs">Status Name:</label>
                <select v-model="new_rule.pass_status" class="form-select form-select-sm text-xxs rounded-small shadow-sm">
                  <option disabled value="">Select status</option>
                  <option value="Verified">Verified</option>
                </select>
              </div>
             
              <label class="modal-form-label form-label text-xxs mt-1">Risk Level:</label>
              <select v-model="new_rule.pass_risk" class="form-select form-select-sm text-xxs rounded-small shadow-sm">
                <option disabled value="">Select risk level</option>
                <option value="Low Risk">Low Risk</option>
              </select>
              <div class="alert alert-success text-xxs mt-3 p-1">
                Entities will be moved to Low Risk category
              </div>
            </div>
            <!-- Failing Status -->
            <div class="border-0 rounded-3 p-3 border">
                  <div class="d-flex align-items-center mb-2">
                    <span class="me-2 text-danger fs-5">✖</span>
                    <p class="mb-0 fw-bold text-dark text-xs">Compliance Check Failing Status :</p>
                  </div>
                  <div>
                    <label class="modal-form-label form-label text-xxs">Status Name:</label>
                    <select v-model="new_rule.fail_status" class="form-select form-select-sm text-xxs rounded-small shadow-sm">
                      <option disabled value="">Select status</option>
                      <option value="Non-Compliant">Non-Compliant</option>
                    </select>
                  </div>
                    
                  <label class="modal-form-label form-label text-xxs mt-1">Risk Level:</label>
                  <select v-model="new_rule.fail_risk" class="form-select form-select-sm text-xxs rounded-small  shadow-sm">
                    <option disabled value="">Select risk level</option>
                    <option value="Medium Risk">Medium Risk</option>
                  </select>
                  <div class="alert alert-warning text-xxs mt-3 p-1">
                    Entities will be moved to Medium Risk category
                  </div>
                </div>
            </div>
        </div>
        <!-- Footer -->
        <div class="modal-footer border-0 p-2 d-flex justify-content-end">
          <button type="button" class="btn btn-primary-dark btn-sm shadow text-xxs" 
            @click="create_a_compliance_rule" 
            :disabled="loading" 
            data-bs-dismiss="modal">
            <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{ loading ? 'Creating...' : 'Save' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
</teleport>

<!-- Edit rule modal -->
 <teleport to="body">
<div id="edit_new_rule" class="modal fade" tabindex="-1" aria-labelledby="edit_rule_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <h6 id="edit_rule_label" class="modal-title text-xxs text-white">Edit Compliance Rule</h6>
        <button type="button" class="modal-btn-close btn-close" aria-label="Close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <div class="modal-form-group form-group mb-3">
          <label class="modal-form-label form-label text-xxs">Rule Name:</label>
          <input type="text" v-model="edit_rule.name" class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm" 
            placeholder="Enter Rule Name" maxlength="50">
          <small v-if="errors.name" class="text-danger p-2 text-xxs fw-bold">{{ errors.name }}</small>
        </div>
        <div class="modal-form-group form-group mb-3">
          <label class="modal-form-label form-label text-xxs">Description:</label>
          <input type="text" v-model="edit_rule.description" class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm" 
            placeholder="Enter Description" maxlength="255">
          <small v-if="errors.description" class="text-danger p-2 text-xxs fw-bold">{{ errors.description }}</small>
        </div>
        <div class="modal-form-group form-group mb-3">
          <label class="modal-form-label form-label text-xxs">Select Data Point:</label>
          <select 
            v-model="edit_rule.data_point_id" 
            class="modal-form-select form-select text-xxs rounded-small p-2 shadow-sm"
            :disabled="data_points_loading"
          >
            <option disabled value="">
              {{ data_points_loading ? 'Loading data points...' : 'Select data point' }}
            </option>
            <option 
              v-for="point in data_points" 
              :key="point.id" 
              :value="point.id"
            >
              {{ point.name }}
            </option>
            <option v-if="data_points.length === 0 && !data_points_loading" disabled>
              No data points available
            </option>
          </select>
        </div>
        
        <!-- Edit Rule Modal - Frequency dropdown -->
        <div class="modal-form-group form-group mb-3">
          <label class="modal-form-label form-label text-xxs">Frequency:</label>
          <select v-model="edit_rule.frequency" class="modal-form-control form-select text-xxs rounded-small p-2 shadow-sm">
            <option disabled value="">Select frequency</option>
            <option 
              v-for="option in frequency_options" 
              :key="option.value" 
              :value="option.value">
              {{ option.label }}
            </option>
          </select>
          <small v-if="errors.frequency" class="text-danger p-2 text-xxs fw-bold">{{ errors.frequency }}</small>
        </div>

        <!-- Edit Rule Modal - Grace Period dropdown -->
        <div class="modal-form-group form-group mb-3">
          <label class="modal-form-label form-label text-xxs">Grace Period:</label>
          <select v-model="edit_rule.grace_period_selection" class="modal-form-control form-select text-xxs rounded-small p-2 shadow-sm mb-2">
            <option value="">Select grace period</option>
            <option 
              v-for="option in grace_period_options" 
              :key="option.value" 
              :value="option.value">
              {{ option.label }}
            </option>
          </select>

          <!-- Custom input for edit -->
          <div v-if="edit_rule.grace_period_selection === 'custom'" class="d-flex align-items-center">
            <input 
              type="number"
              v-model.number="edit_rule.custom_grace_period_days" 
              class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm me-2"
              min="0" 
              max="365" 
              placeholder="Enter days"
            >
            <span class="text-xxs text-muted">day(s)</span>
          </div>

          <small v-if="errors.grace_period_days" class="text-danger p-2 text-xxs fw-bold">{{ errors.grace_period_days }}</small>
          <small class="text-muted text-xxs">Additional time allowed before marking as non-compliant</small>
        </div>

        <!-- Edit Rule Modal - File Age dropdown -->
        <div class="modal-form-group form-group mb-3">
          <label class="modal-form-label form-label text-xxs">Maximum File Age:</label>
          <select v-model="edit_rule.age_selection" class="modal-form-control form-select text-xxs rounded-small p-2 shadow-sm mb-2">
            <option value="">Select maximum file age</option>
            <option 
              v-for="option in file_age_options" 
              :key="option.value" 
              :value="option.value">
              {{ option.label }}
            </option>
          </select>

          <!-- Custom input for edit -->
          <div v-if="edit_rule.age_selection === 'custom'" class="d-flex align-items-center">
            <input 
              type="number"
              v-model.number="edit_rule.custom_age_days" 
              class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm me-2"
              min="1" 
              max="3650" 
              placeholder="Enter days"
            >
            <span class="text-xxs text-muted">day(s)</span>
          </div>

          <small v-if="errors.allowed_age" class="text-danger p-2 text-xxs fw-bold">{{ errors.allowed_age }}</small>
          <small class="text-muted text-xxs">Files older than this will be considered non-compliant</small>
        </div>

        <div class="modal-form-group form-group mb-3">
          <div class="form-check form-switch">
            <input 
              class="form-check-input" 
              type="checkbox" 
              id="edit_rule_active"
              v-model="edit_rule.is_active"
              :disabled="edit_rule.is_archived"
            >
            <label class="form-check-label text-xxs fw-medium" for="edit_rule_active">
              {{ edit_rule.is_active ? 'Active' : 'Inactive' }}
            </label>
          </div>
          <small class="text-muted text-xxs">
            <span v-if="edit_rule.is_archived" class="text-warning">
              Archived rules cannot be modified
            </span>
            <span v-else>
              {{ edit_rule.is_active ? 'Rule will run compliance checks after saving' : 'Rule will not run compliance checks after saving' }}
            </span>
          </small>
        </div>
      </div>
      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button type="button" class="btn btn-primary-dark btn-sm shadow text-xxs" 
          @click="update_compliance_rule" :disabled="loading" data-bs-dismiss="modal">
          <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {{ loading ? 'Saving...' : 'Save' }}
        </button>
      </div>
    </div>
  </div>
</div>
</teleport>

<!-- Updated Rule History Modal with Timeline -->
 <teleport to="body">
<div id="rule_history_modal" class="modal fade" tabindex="-1" aria-labelledby="rule_history_label" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0">
      <div class="modal-header border-bottom-0 cute-header shadow-sm">
        <h6 id="rule_history_label" class="modal-title text-white">Compliance Rule History</h6>
        <button type="button" class="modal-btn-close btn-close" aria-label="Close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <!-- Loading state for history -->
        <div v-if="history_loading" class="text-center py-4">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <p class="text-muted mt-2">Loading rule history...</p>
        </div>
        
        <!-- No data state -->
        <div v-else-if="rule_history_data.length === 0" class="text-center py-4">
          <p class="text-muted">No history data available</p>
        </div>
        
        <!-- Timeline content -->
        <div v-else class="card border-0 p-3">
          <h5 class="card-title mt-2 mb-3">{{ selected_rule_name }}</h5>
          <div class="card-body position-relative ">
            <div class="timeline-line position-absolute top-0 bottom-0 start-0 ms-4"></div>
            <!-- Scrollable container -->
            <div class="timeline-scrollable me-1 status-overflow">
              <div
                v-for="(entry, index) in rule_history_data"
                :key="index"
                class="timeline-entry d-flex flex-column position-relative mb-5"
              >
                <div class="timeline-dot position-absolute top-left">
                  <span class="dot custom-header"></span>
                </div>
                <div class="ms-4 mb-1">
                  <small class="fw-bold text-xs">{{ format_date(entry.created_at) }}</small>
                </div>
                <div class="ms-4 flex-grow-1 shadow rounded-lg">
                  <div class="border rounded-lg p-3">
                    <div class="fw-semibold text-xs">
                      Version {{ entry.version }} - {{ entry.is_archived ? 'Archived' : 'Current' }}
                    </div>
                    <div class="text-muted text-xxs">{{ entry.description || 'No description available' }}</div>
                    <div class="mt-2">
                      <button 
                        class="d-none btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark me-2"
                        @click="view_rule_details(entry)"
                        data-bs-dismiss="modal">
                        View Details
                      </button>
                      <button 
                        v-if="!entry.is_archived && !entry.is_active"
                        class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                        @click="restore_rule_version(entry.id)">
                        Restore
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</teleport>